const initState = {
    authError: null
};

export const auth = ( state = initState, action ) => {

    switch (action.type) {
        case 'CREATE_USER_SUCCESS':
            return {
                ...state,
                uid: action.uid,
                authError: null
            }
        case 'SIGNIN_SUCCESS':
            return {
                ...state,
                uid: action.uid,
                authError: null
            }
        case 'SIGNIN_FAILED':
            return {
                ...state,
                authError: action.err.message
            }
        default: return state
    }

};